import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

import { FileElement } from '../common/file-manager/model/file-element';
import { EnvConfigurationService } from './config/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FileBrowserService {
  private querySubject: BehaviorSubject<FileElement[]>;
  private map = new Map<string, FileElement>();

  constructor(private http: HttpClient) {}

  add(fileElement: FileElement): void {
    this.map.set(fileElement.id, fileElement);
  }

  delete(id: string): void {
    this.map.delete(id);
  }

  update(id: string, update: Partial<FileElement>): void {
    let element = this.map.get(id);
    element = Object.assign(element, update);
    this.map.set(element.id, element);
  }

  queryInFolder(folderId: string): Observable<FileElement[]> {
    const result: FileElement[] = [];
    this.map.forEach(element => {
      if (element.parent === folderId) {
        result.push(this.clone(element));
      }
    });
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result);
    } else {
      this.querySubject.next(result);
    }
    return this.querySubject.asObservable();
  }

  get(id: string): FileElement {
    return this.map.get(id);
  }

  clone(element: FileElement): any {
    return JSON.parse(JSON.stringify(element));
  }

  getFileElements(path: string): Observable<FileElement[]> {
    let parameters = new HttpParams();
    parameters = parameters.append('path', path);
    return this.http.get<FileElement[]>(`${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/admin/file-elements`, {params: parameters});
 }

  deleteFileElement(path: string): Observable<any> {
    let parameters = new HttpParams();
    parameters = parameters.append('path', path);
    return this.http.delete(`${EnvConfigurationService.configuration.API_BASE_URL}/api/v2/admin/file-elements-delete`,
      { params: parameters });
  }

}
